import React from "react";
import { Box, Typography, Paper } from "@mui/material";

export default function RefundPolicy() {
  return (
    <Box
      sx={{
        background: "linear-gradient(180deg, #fff3e0 0%, #ffe0b2 100%)",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        pt: "10vw",
        pb: 8,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 6,
          width: "80%",
          maxWidth: "900px",
          borderRadius: "20px",
          backgroundColor: "rgba(255,255,255,0.9)",
          backdropFilter: "blur(8px)",
          boxShadow: "0px 10px 25px rgba(255, 102, 0, 0.2)",
        }}
      >
        <Typography variant="h3" sx={{ textAlign: "center", fontWeight: 800, color: "#ff6600", mb: 4 }}>
          Refund Policy
        </Typography>

        <Typography variant="body1" sx={{ fontSize: "1.15rem", fontWeight: 500, mb: 2 }}>
          We appreciate your trust in <strong>Cosmical Calculator</strong>. Please review
          our refund policy before making any payment.
        </Typography>

        <Typography variant="body1" sx={{ fontSize: "1.15rem", fontWeight: 500, mb: 2 }}>
          <strong>1. Non-Refundable Services:</strong> Once an astrological reading or
          report is delivered, it cannot be refunded due to its personalized nature.
        </Typography>

        <Typography variant="body1" sx={{ fontSize: "1.15rem", fontWeight: 500, mb: 2 }}>
          <strong>2. Duplicate Payments:</strong> If a duplicate payment occurs, contact us
          at <span style={{ color: "#ff6600", fontWeight: 700 }}>cosmicalculator@gmail.com</span>{" "}
          within 7 days for resolution.
        </Typography>

        <Typography variant="body1" sx={{ fontSize: "1.15rem", fontWeight: 500, mb: 2 }}>
          <strong>3. Refund Processing:</strong> Approved refunds are issued to the
          original payment method within 7–10 business days.
        </Typography>

        <Typography variant="body1" sx={{ fontSize: "1.15rem", fontWeight: 500 }}>
          <strong>4. Changes to Policy:</strong> Cosmical Calculator reserves the right to
          amend this policy at any time without prior notice.
        </Typography>
      </Paper>
    </Box>
  );
}
